import React from 'react'
import { Link } from 'gatsby-link'
import { Article } from '../../types/tree'

interface ArticleListProps {
  articles: Article[]
  categorySlug: string | undefined
  productSlug: string
}

const ArticleList = (props: ArticleListProps) => {
  const {
    articles
  } = props

  return (
    <ul className='list-unstyled mb-0'>
      {
        articles.map((article, index) => {
          let { _slug } = article
          return (
              <li
                key={`article-${index}`}
              >
                <Link
                  className='d-inline-block text-black'
                  to={_slug}
                >
                  {article.title}
                </Link>
              </li>
          )
        }
        )
      }
    </ul>
  )
}

export default ArticleList
